// import { Calendar, CheckCircle, ChevronRight, Clock as ClockIcon, Edit3, Eye, Grid, Loader, Table, Truck, X, XCircle } from "lucide-react";
// import { useEffect, useMemo, useState } from "react";
// import { toast } from "react-toastify";
// import { useScheduledBookings } from "../hooks/useScheduledBookings";
// import api from "../services/api";
// import { getForkBookingDetails } from "../services/bookingService";
// import { getAllWorkAreas } from "../services/workAreaService";
// import BookingRequestList from "./Bookingrequestlist";

// const RESOURCE_TYPES = ["Trailer", "Crane"];

// // Status Edit Modal Component (Only for changing status)
// const StatusEditModal = ({ booking, onClose, onSave, isSaving, onRefresh }) => {
//   const [loading, setLoading] = useState(true);
//   const [fetchError, setFetchError] = useState(null);
//   const [fullBookingData, setFullBookingData] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [workAreas, setWorkAreas] = useState([]);
//   const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
//   const workAreaOptions = useMemo(() => workAreas.map((w) => ({ value: w.name, label: w.name })), [workAreas]);

//   const parseDateFromTime = (dateStr) => {
//     if (!dateStr) return "";
//     if (dateStr.includes("-") && dateStr.length >= 10) return dateStr.split(" ")[0];
//     const parts = dateStr.split(" ");
//     if (parts[0] && parts[0].includes("/")) {
//       const dateParts = parts[0].split("/");
//       if (dateParts.length === 3) {
//         const month = dateParts[0].padStart(2, "0");
//         const day = dateParts[1].padStart(2, "0");
//         const year = dateParts[2];
//         return `${year}-${month}-${day}`;
//       }
//     }
//     return "";
//   };

//   const parseTimeFromBooking = (dateStr) => {
//     if (!dateStr) return "";
//     const parts = dateStr.split(" ");
//     if (parts[1]) {
//       const timeParts = parts[1].split(":");
//       if (timeParts.length >= 2) {
//         const hour = timeParts[0].padStart(2, "0");
//         const min = timeParts[1].padStart(2, "0");
//         return `${hour}:${min}`;
//       }
//     }
//     return "";
//   };

//   useEffect(() => {
//     const fetchFullBooking = async () => {
//       if (!booking?.bId && !booking?.scheduledBookingId) {
//         setFetchError("Booking ID is missing.");
//         setLoading(false);
//         return;
//       }
//       setLoading(true);
//       setFetchError(null);
//       try {
//         const bookingId = booking.bId || booking.scheduledBookingId;
//         const data = await getForkBookingDetails(bookingId);
//         if (!data) throw new Error("No data returned from API.");
//         setFullBookingData(data);
        
//         // Set current status
//         let currentStatus = "";
//         if (data.status === "I" || data.status.toLowerCase().includes("inactive") || data.status.toLowerCase() === "scheduled") currentStatus = "Pending";
//         else if (data.status === "A" || data.status.toLowerCase().includes("active")) currentStatus = "Active";
//         else if (data.status === "C" || data.status.toLowerCase().includes("cancel")) currentStatus = "Cancelled";
//         else if (data.status === "Completed") currentStatus = "Completed";
        
//         setSelectedStatus(currentStatus);
//       } catch (err) {
//         setFetchError(err.message || "An error occurred while fetching booking details.");
//         // Set default status from booking object
//         setSelectedStatus(booking.status || "Pending");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchFullBooking();
//   }, [booking]);

//   useEffect(() => {
//     const loadWorkAreas = async () => {
//       setLoadingWorkAreas(true);
//       try {
//         const data = await getAllWorkAreas();
//         setWorkAreas(data);
//       } catch (err) {} finally {
//         setLoadingWorkAreas(false);
//       }
//     };
//     loadWorkAreas();
//   }, []);

//   const handleStatusChange = (newStatus) => {
//     setSelectedStatus(newStatus);
//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();
  
//   const currentStatus = booking.status;
  
//   // Only allow Pending -> Completed
//   if (currentStatus !== "Pending" && currentStatus !== "Active" && currentStatus !== "Enroute" && currentStatus !== "In Progress") {
//     toast.error("Only pending bookings can be marked as completed");
//     return;
//   }
  
//   if (selectedStatus !== "Completed") {
//     toast.error("Only 'Complete' action is allowed");
//     return;
//   }

//   const bookingId = booking.bId || booking.scheduledBookingId;
//   const now = new Date();
//   const bookingDT = now.toISOString().slice(0, 19).replace("T", " ");
//   const bsTime = now.toISOString().slice(0, 19).replace("T", " ");
  
//   // Create payload matching the exact format you showed
//   const updatePayload = {
//     bId: bookingId || "",
//     vId: fullBookingData?.vId || booking.vehicleId ,
//     dSNo: fullBookingData?.dSNo || booking.dSNo ,
//     slatitude: fullBookingData?.slatitude ,
//     slongitude: fullBookingData?.slongitude ,
//     elatitude: fullBookingData?.elatitude ,
//     elongitude: fullBookingData?.elongitude ,
//     status: "CO",  
//     bookingDT: bookingDT,
//     bsTime: bsTime,
//     beTime: fullBookingData?.beTime || null,
//     totalDestence: fullBookingData?.totalDestence || "0",
//     dlongitude: fullBookingData?.dlongitude ,
//     dlatitude: fullBookingData?.dlatitude ,
//     bookingSno: fullBookingData?.bookingSno || booking.bookedBy ,
//     WorkArea: fullBookingData?.WorkArea || booking.workArea || null,
//     WorkScope: fullBookingData?.WorkScope || booking.workScope || null,
//     Priority: fullBookingData?.Priority || booking.priority || null,
//     From: fullBookingData?.From || booking.fromLocation ,
//     TO: fullBookingData?.TO || booking.toLocation ,
//     Remark: fullBookingData?.Remark || booking.remark || "",
//     SubBook: fullBookingData?.SubBook ,
//     BookingStatus: "R"  
//   };
 
//   await onSave(updatePayload);
// };
 
//   const getBookingInfo = () => {
//     return {
//       id: booking.bId || booking.scheduledBookingId,
//       vehicleId: booking.vehicleId || fullBookingData?.vId || "N/A",
//       fromLocation: booking.fromLocation || fullBookingData?.From || "N/A",
//       toLocation: booking.toLocation || fullBookingData?.TO || "N/A",
//       date: booking.bookedDate || (fullBookingData?.bsTime ? parseDateFromTime(fullBookingData.bsTime) : "N/A"),
//       time: booking.startTime ? `${booking.startTime} - ${booking.endTime}` : 
//             (fullBookingData?.bsTime ? `${parseTimeFromBooking(fullBookingData.bsTime)} - ${parseTimeFromBooking(fullBookingData.beTime)}` : "N/A"),
//     };
//   };

//   if (loading) {
//     return (
//       <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//         <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-8 text-center">
//           <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
//           <p className="text-sm text-gray-500">Loading booking details...</p>
//         </div>
//       </div>
//     );
//   }

//   const info = getBookingInfo();
//   const currentStatus = booking.status;
//   const canMarkComplete = currentStatus === "Pending" || currentStatus === "Active" || currentStatus === "Enroute" || currentStatus === "In Progress";

//   return (
//     <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
//         <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-blue-50 rounded-lg">
//               <Edit3 size={16} className="text-blue-600" />
//             </div>
//             <h2 className="text-base font-semibold text-gray-900">Update Booking Status</h2>
//           </div>
//           <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
//             <X size={16} className="text-gray-400" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-5">
//           {fetchError && (
//             <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
//               <p className="text-xs text-yellow-700">{fetchError}</p>
//             </div>
//           )}

//           {/* Booking Summary - Read Only */}
//           <div className="bg-gray-50 rounded-lg p-4 space-y-2">
//             <h3 className="text-xs font-semibold text-gray-700 mb-2">Booking Details</h3>
//             <div className="grid grid-cols-2 gap-2 text-sm">
//               <div>
//                 <label className="text-[10px] font-medium text-gray-500">Booking ID</label>
//                 <p className="text-xs font-mono text-gray-900">{info.id}</p>
//               </div>
//               <div>
//                 <label className="text-[10px] font-medium text-gray-500">Vehicle</label>
//                 <p className="text-xs text-gray-900">{info.vehicleId}</p>
//               </div>
//               <div className="col-span-2">
//                 <label className="text-[10px] font-medium text-gray-500">Route</label>
//                 <p className="text-xs text-gray-900">{info.fromLocation} → {info.toLocation}</p>
//               </div>
//               <div>
//                 <label className="text-[10px] font-medium text-gray-500">Date</label>
//                 <p className="text-xs text-gray-900">{info.date}</p>
//               </div>
//               <div>
//                 <label className="text-[10px] font-medium text-gray-500">Time</label>
//                 <p className="text-xs text-gray-900">{info.time}</p>
//               </div>
//             </div>
//           </div>

//           {/* Status Update Section */}
//           <div>
//             <label className="block text-xs font-medium text-gray-700 mb-2">Current Status</label>
//             <div className="mb-4 p-3 bg-gray-50 rounded-lg">
//               <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
//                 currentStatus === "Pending" ? "bg-yellow-50 text-yellow-700" :
//                 currentStatus === "Completed" ? "bg-emerald-50 text-emerald-700" :
//                 "bg-red-50 text-red-700"
//               }`}>
//                 {currentStatus}
//               </span>
//             </div>

//             <label className="block text-xs font-medium text-gray-700 mb-2">Update Status To</label>
//             <div className="space-y-2">
//               {/* Only show Complete option if booking is Pending */}
//               {canMarkComplete && (
//                 <button
//                   type="button"
//                   onClick={() => handleStatusChange("Completed")}
//                   className={`w-full flex items-center justify-between p-3 rounded-lg border-2 transition ${
//                     selectedStatus === "Completed"
//                       ? "border-emerald-500 bg-emerald-50"
//                       : "border-gray-200 hover:border-emerald-200"
//                   }`}
//                 >
//                   <div className="flex items-center gap-3">
//                     <CheckCircle size={18} className={selectedStatus === "Completed" ? "text-emerald-600" : "text-gray-400"} />
//                     <div className="text-left">
//                       <p className="text-sm font-medium text-gray-900">Complete</p>
//                       <p className="text-xs text-gray-500">Mark this booking as completed</p>
//                     </div>
//                   </div>
//                   {selectedStatus === "Completed" && <CheckCircle size={16} className="text-emerald-600" />}
//                 </button>
//               )}
              
//               {/* Show current status as disabled if not Pending */}
//               {!canMarkComplete && currentStatus !== "Completed" && (
//                 <div className="p-3 bg-gray-100 rounded-lg text-center">
//                   <p className="text-xs text-gray-500">
//                     {currentStatus === "Cancelled" 
//                       ? "Cancelled bookings cannot be modified" 
//                       : "This booking cannot be modified"}
//                   </p>
//                 </div>
//               )}

//               {currentStatus === "Completed" && (
//                 <div className="p-3 bg-emerald-50 rounded-lg text-center">
//                   <CheckCircle size={16} className="text-emerald-600 inline mr-2" />
//                   <p className="text-xs text-emerald-700 inline">This booking has already been completed</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="flex gap-3 pt-2">
//             <button type="button" onClick={onClose} className="flex-1 px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
//               Cancel
//             </button>
//             <button 
//               type="submit" 
//               disabled={isSaving || !canMarkComplete || selectedStatus === currentStatus} 
//               className="flex-1 px-3 py-1.5 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition disabled:opacity-50 flex items-center justify-center gap-1"
//             >
//               {isSaving ? <><Loader size={14} className="animate-spin" /> Saving...</> : "Update Status"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// // Booking Details Modal Component
// const BookingDetailsModal = ({ booking, onClose, onCancel, isCancelling }) => {
//   const [detailedData, setDetailedData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [vehicleInfo, setVehicleInfo] = useState(null);
//   const [resources, setResources] = useState([]);
//   const [vehicleCatalog, setVehicleCatalog] = useState({});

//   useEffect(() => {
//     const fetchBookingDetails = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const bidValue = booking.bId || booking.scheduledBookingId;
//         const [response, vehiclesResponse] = await Promise.all([
//           api.get(`BookingRegister/GetMainForkBookingDetails?bid=${bidValue}`),
//           api.get("VehicleDetails/GetVehicleDetails"),
//         ]);
//         const vehicles = vehiclesResponse?.data?.resultSet || [];
//         const vehicleMap = vehicles.reduce((acc, item) => { if (item?.vehicleId) acc[item.vehicleId] = item; return acc; }, {});
//         setVehicleCatalog(vehicleMap);
//         if (response.data?.resultSet && Array.isArray(response.data.resultSet) && response.data.resultSet.length > 0) {
//           setDetailedData(response.data.resultSet);
//           setVehicleInfo(response.data.resultSet[0]);
//           setResources(response.data.resultSet.slice(1));
//         } else {
//           setError("No booking details found");
//         }
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load booking details");
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (booking?.scheduledBookingId || booking?.bId) fetchBookingDetails();
//   }, [booking?.scheduledBookingId, booking?.bId]);

//   const formatReadableDate = (value) => {
//     if (!value) return "-";
//     const date = new Date(value);
//     if (isNaN(date.getTime())) return "-";
//     return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const formatReadableTime = (value) => {
//     if (!value) return "-";
//     const date = new Date(value);
//     if (isNaN(date.getTime())) return "-";
//     return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Pending": return "bg-yellow-50 text-yellow-700 border-yellow-200";
//       case "Completed": return "bg-emerald-50 text-emerald-700 border-emerald-200";
//       case "Cancelled": return "bg-red-50 text-red-700 border-red-200";
//       default: return "bg-gray-50 text-gray-700 border-gray-200";
//     }
//   };

//   if (loading) {
//     return (
//       <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//         <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-8 text-center">
//           <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
//           <p className="text-sm text-gray-500">Loading booking details...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//         <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-blue-50 rounded-lg">
//               <Eye size={16} className="text-blue-600" />
//             </div>
//             <h2 className="text-base font-semibold text-gray-900">Booking Details</h2>
//           </div>
//           <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
//             <X size={16} className="text-gray-400" />
//           </button>
//         </div>

//         <div className="p-6 space-y-5">
//           {error && (
//             <div className="bg-red-50 border border-red-200 rounded-lg p-3">
//               <p className="text-xs text-red-700">{error}</p>
//             </div>
//           )}

//           {!error && vehicleInfo && (
//             <>
//               <div className="flex items-center gap-2">
//                 <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(booking.status)}`}>
//                   {booking.status === "Pending" && <ClockIcon size={10} />}
//                   {booking.status === "Completed" && <CheckCircle size={10} />}
//                   {booking.status === "Cancelled" && <XCircle size={10} />}
//                   {booking.status}
//                 </span>
//               </div>

//               <div className="grid grid-cols-2 gap-3">
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <label className="text-[10px] font-medium text-gray-500 uppercase">Vehicle ID</label>
//                   <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.vId || "N/A"}</p>
//                 </div>
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <label className="text-[10px] font-medium text-gray-500 uppercase">Booking ID</label>
//                   <p className="text-sm font-semibold text-gray-900 mt-1 font-mono">{vehicleInfo.bId || "N/A"}</p>
//                 </div>
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <label className="text-[10px] font-medium text-gray-500 uppercase flex items-center gap-1">📅 Date</label>
//                   <p className="text-sm font-semibold text-gray-900 mt-1">{formatReadableDate(vehicleInfo.bsTime)}</p>
//                 </div>
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <label className="text-[10px] font-medium text-gray-500 uppercase flex items-center gap-1">⏰ Time</label>
//                   <p className="text-sm font-semibold text-gray-900 mt-1">{formatReadableTime(vehicleInfo.bsTime)} - {formatReadableTime(vehicleInfo.beTime)}</p>
//                 </div>
//               </div>

//               {(vehicleInfo.From || vehicleInfo.TO) && (
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <h3 className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1">📍 Route</h3>
//                   <div className="space-y-2">
//                     {vehicleInfo.From && (
//                       <div className="flex items-center gap-2">
//                         <div className="w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold">A</div>
//                         <p className="text-sm text-gray-900">{vehicleInfo.From}</p>
//                       </div>
//                     )}
//                     {vehicleInfo.TO && (
//                       <div className="flex items-center gap-2">
//                         <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold">B</div>
//                         <p className="text-sm text-gray-900">{vehicleInfo.TO}</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {(vehicleInfo.Priority || vehicleInfo.WorkArea) && (
//                 <div className="grid grid-cols-2 gap-3">
//                   {vehicleInfo.Priority && (
//                     <div className="bg-gray-50 rounded-lg p-3">
//                       <label className="text-[10px] font-medium text-gray-500 uppercase">Priority</label>
//                       <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.Priority}</p>
//                     </div>
//                   )}
//                   {vehicleInfo.WorkArea && (
//                     <div className="bg-gray-50 rounded-lg p-3">
//                       <label className="text-[10px] font-medium text-gray-500 uppercase">Work Area</label>
//                       <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.WorkArea}</p>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {vehicleInfo.Remark && (
//                 <div className="bg-gray-50 rounded-lg p-3">
//                   <label className="text-[10px] font-medium text-gray-500 uppercase">Remarks</label>
//                   <p className="text-sm text-gray-700 mt-1">{vehicleInfo.Remark}</p>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div className="border-t border-gray-100 px-6 py-4 flex gap-3">
//           <button onClick={onClose} className="flex-1 px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
//             Close
//           </button>
//           {booking.status !== "Cancelled" && booking.status !== "Completed" && (
//             <button onClick={() => { if (window.confirm("Cancel this booking?")) onCancel(booking.scheduledBookingId); }} disabled={isCancelling} className="flex-1 px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50 flex items-center justify-center gap-1">
//               <XCircle size={14} /> {isCancelling ? "Cancelling..." : "Cancel Booking"}
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Main ScheduledBookingList Component
// const ScheduledBookingList = () => {
//   const { bookings, cancel, cancellingMap, loadBookings } = useScheduledBookings();
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [editingBooking, setEditingBooking] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [viewMode, setViewMode] = useState('table');

//   // Detect screen size for default view
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 768) {
//         setViewMode('card');
//       } else {
//         setViewMode('table');
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const filteredBookings = useMemo(() => {
//     if (statusFilter === "All") return bookings;
//     return bookings.filter((booking) => booking.status === statusFilter);
//   }, [bookings, statusFilter]);

//   const handleCancel = async (scheduledBookingId) => {
//     if (!scheduledBookingId) return;
//     try {
//       await cancel(scheduledBookingId);
//       setSelectedBooking(null);
//     } catch (error) {
//       console.error("Failed to cancel scheduled booking:", error);
//     }
//   };

//   // Update booking status using appropriate API
// // Update booking status using appropriate API - Array format
// const handleStatusUpdate = async (updatePayload) => {
//   if (!editingBooking) return;
//   setIsSaving(true);
//   try {
//     // Wrap the payload in an array as required by the API
//     const payloadArray = [updatePayload];
    
//     // Log to verify the payload format
//     console.log("Sending payload array:", JSON.stringify(payloadArray, null, 2));
    
//     // Use update API endpoint with array payload
//     const response = await api.put(`BookingRegister/PostForkBooking`, payloadArray);
//     const responseData = response?.data;
    
//     console.log("Response:", responseData);
    
//     if (responseData?.statusCode && responseData.statusCode !== 200) {
//       throw new Error(responseData.result || `Backend error: ${responseData.statusCode}`);
//     }
    
//     toast.success("Booking status updated successfully");
//     setEditingBooking(null);
//     setSelectedBooking(null);
//     await loadBookings();
//   } catch (error) {
//     console.error("Failed to update booking status:", error);
//     toast.error(error.message || "Failed to update booking status");
//   } finally {
//     setIsSaving(false);
//   }
// };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Pending":
//         return "bg-yellow-50 text-yellow-700";
//       case "Completed":
//         return "bg-emerald-50 text-emerald-700";
//       case "Cancelled":
//         return "bg-red-50 text-red-700";
//       default:
//         return "bg-gray-50 text-gray-700";
//     }
//   };

//   const getStatusIcon = (status) => {
//     switch (status) {
//       case "Pending":
//         return <ClockIcon size={10} />;
//       case "Completed":
//         return <CheckCircle size={10} />;
//       case "Cancelled":
//         return <XCircle size={10} />;
//       default:
//         return null;
//     }
//   };

//   // Mobile Card Component
//   const BookingCard = ({ booking }) => {
//     const statusColor = getStatusColor(booking.status);
//     const statusIcon = getStatusIcon(booking.status);
//     const fromValue = booking.fromLocation || booking.From || booking.workArea;
//     const toValue = booking.toLocation || booking.TO;

//     return (
//       <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition">
//         <div className="p-3 border-b border-gray-100 bg-gray-50">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <span className="text-xs font-semibold text-gray-900">#{booking.bId || booking.scheduledBookingId}</span>
//               <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${statusColor}`}>
//                 {statusIcon}
//                 {booking.status}
//               </span>
//             </div>
//           </div>
//           {(booking.bookedDate || booking.startTime) && (
//             <p className="text-[10px] text-gray-500 mt-1">
//               {booking.bookedDate || ""} {booking.startTime ? `• ${booking.startTime}` : ""}
//             </p>
//           )}
//         </div>

//         <div className="p-3 space-y-2">
//           <div className="flex items-start gap-2">
//             <div className="w-5 h-5 bg-emerald-500 rounded-full flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">A</div>
//             <p className="text-xs text-gray-700 flex-1">{fromValue || "—"}</p>
//           </div>
//           <div className="flex items-start gap-2">
//             <div className="w-5 h-5 bg-red-500 rounded-full flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">B</div>
//             <p className="text-xs text-gray-700 flex-1">{toValue || "—"}</p>
//           </div>
//           {(booking.vehicleId || booking.vehicleName) && (
//             <div className="pt-2 border-t border-gray-100">
//               <div className="flex items-center gap-1.5">
//                 <Truck size={12} className="text-gray-400" />
//                 <span className="text-xs font-medium text-gray-900">{booking.vehicleId || booking.vehicleName}</span>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="flex gap-2 p-3 bg-gray-50 border-t border-gray-100">
//           <button onClick={() => setSelectedBooking(booking)} className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition">
//             <Eye size={12} /> View
//           </button>
//           {/* Only show Edit button for Pending bookings */}
//           {booking.status === "Pending" && (
//             <button 
//               onClick={() => setEditingBooking(booking)} 
//               className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition"
//             >
//               <Edit3 size={12} /> Complete
//             </button>
//           )}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="space-y-4">
//       {/* Header with Filters */}
//       <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//           <div className="flex items-center gap-2">
//             <Calendar size={16} className="text-gray-500" />
//             <h2 className="text-sm font-semibold text-gray-900">Your Bookings</h2>
//           </div>
//           <div className="flex gap-1.5 overflow-x-auto pb-1">
//             {["All", "Pending", "Completed", "Cancelled"].map((status) => (
//               <button
//                 key={status}
//                 onClick={() => setStatusFilter(status)}
//                 className={`px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap transition ${
//                   statusFilter === status
//                     ? "bg-gray-900 text-white"
//                     : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                 }`}
//               >
//                 {status}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* View Toggle for Desktop */}
//       <div className="hidden md:flex justify-end">
//         <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg">
//           <button
//             onClick={() => setViewMode('table')}
//             className={`px-2.5 py-1 text-xs font-medium rounded transition ${
//               viewMode === 'table' 
//                 ? 'bg-white text-gray-900 shadow-sm' 
//                 : 'text-gray-600 hover:text-gray-900'
//             }`}
//           >
//             <Table size={12} className="inline mr-1" />
//             Table View
//           </button>
//           <button
//             onClick={() => setViewMode('card')}
//             className={`px-2.5 py-1 text-xs font-medium rounded transition ${
//               viewMode === 'card' 
//                 ? 'bg-white text-gray-900 shadow-sm' 
//                 : 'text-gray-600 hover:text-gray-900'
//             }`}
//           >
//             <Grid size={12} className="inline mr-1" />
//             Card View
//           </button>
//         </div>
//       </div>

//       {/* Desktop Table View */}
//       {viewMode === 'table' && (
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hidden md:block">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-50 border-b border-gray-100">
//                 <tr>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Vehicle</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">From → To</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-50">
//                 {filteredBookings.map((booking) => {
//                   const fromValue = booking.fromLocation || booking.From || booking.workArea || "—";
//                   const toValue = booking.toLocation || booking.TO || "—";
//                   const statusColor = getStatusColor(booking.status);
//                   const statusIcon = getStatusIcon(booking.status);
                  
//                   return (
//                     <tr key={booking.bId || booking.scheduledBookingId} className="hover:bg-gray-50/50 transition">
//                       <td className="py-2.5 px-3">
//                         <span className="text-xs font-mono font-medium text-gray-900">#{booking.bId || booking.scheduledBookingId}</span>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="flex items-center gap-1.5">
//                           <Truck size={12} className="text-gray-400" />
//                           <span className="text-xs text-gray-700">{booking.vehicleId || booking.vehicleName || "—"}</span>
//                         </div>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="flex items-center gap-1 text-xs text-gray-600">
//                           <span className="truncate max-w-[120px]">{fromValue}</span>
//                           <ChevronRight size={10} className="text-gray-400" />
//                           <span className="truncate max-w-[120px]">{toValue}</span>
//                         </div>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="text-xs text-gray-600">
//                           <div>{booking.bookedDate || "—"}</div>
//                           <div className="text-[10px] text-gray-400">{booking.startTime ? `${booking.startTime} - ${booking.endTime || "—"}` : "—"}</div>
//                         </div>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${statusColor}`}>
//                           {statusIcon}
//                           {booking.status}
//                         </span>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="flex gap-1.5">
//                           <button onClick={() => setSelectedBooking(booking)} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition" title="View">
//                             <Eye size={14} />
//                           </button>
//                           {/* Only show Edit button for Pending bookings */}
//                           {(booking.status === "Pending" || booking.status === "Active" || booking.status === "Enroute" || booking.status === "In Progress") && (
//                             <button onClick={() => setEditingBooking(booking)} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition" title="Mark as Complete">
//                               <Edit3 size={14} />
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* Mobile Card View */}
//       {viewMode === 'card' && (
//         <div className="grid grid-cols-1 gap-3">
//           {filteredBookings.map((booking) => (
//             <BookingCard key={booking.bId || booking.scheduledBookingId} booking={booking} />
//           ))}
//         </div>
//       )}

//       {/* Empty State */}
//       {filteredBookings.length === 0 && (
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-12 text-center">
//           <div className="flex flex-col items-center gap-2">
//             <Calendar size={32} className="text-gray-300" />
//             <p className="text-sm font-medium text-gray-900">No Bookings Found</p>
//             <p className="text-xs text-gray-500">
//               {statusFilter === "All" ? "You haven't created any bookings yet." : `No ${statusFilter.toLowerCase()} bookings.`}
//             </p>
//           </div>
//         </div>
//       )}

//       <BookingRequestList />

//       {/* Details Modal */}
//       {selectedBooking && (
//         <BookingDetailsModal
//           booking={selectedBooking}
//           onClose={() => setSelectedBooking(null)}
//           onCancel={handleCancel}
//           isCancelling={cancellingMap?.[selectedBooking.scheduledBookingId]}
//         />
//       )}

//       {/* Status Edit Modal */}
//       {editingBooking && (
//         <StatusEditModal
//           booking={editingBooking}
//           onClose={() => setEditingBooking(null)}
//           onSave={handleStatusUpdate}
//           isSaving={isSaving}
//         />
//       )}
//     </div>
//   );
// };

// export default ScheduledBookingList;





import { Calendar, CheckCircle, ChevronRight, Clock as ClockIcon, Edit3, Eye, Grid, Loader, Table, Truck, X, XCircle } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useScheduledBookings } from "../hooks/useScheduledBookings";
import api from "../services/api";
import { getForkBookingDetails } from "../services/bookingService";
import { getAllWorkAreas } from "../services/workAreaService";
import bookingWS from "../services/bookingWebSocket"; // Import WebSocket
import BookingRequestList from "./Bookingrequestlist";

const RESOURCE_TYPES = ["Trailer", "Crane"];

// Status Edit Modal Component
const StatusEditModal = ({ booking, onClose, onSave, isSaving, onRefresh }) => {
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [fullBookingData, setFullBookingData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [workAreas, setWorkAreas] = useState([]);
  const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
  const workAreaOptions = useMemo(() => workAreas.map((w) => ({ value: w.name, label: w.name })), [workAreas]);

  const parseDateFromTime = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr.includes("-") && dateStr.length >= 10) return dateStr.split(" ")[0];
    const parts = dateStr.split(" ");
    if (parts[0] && parts[0].includes("/")) {
      const dateParts = parts[0].split("/");
      if (dateParts.length === 3) {
        const month = dateParts[0].padStart(2, "0");
        const day = dateParts[1].padStart(2, "0");
        const year = dateParts[2];
        return `${year}-${month}-${day}`;
      }
    }
    return "";
  };

  const parseTimeFromBooking = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split(" ");
    if (parts[1]) {
      const timeParts = parts[1].split(":");
      if (timeParts.length >= 2) {
        const hour = timeParts[0].padStart(2, "0");
        const min = timeParts[1].padStart(2, "0");
        return `${hour}:${min}`;
      }
    }
    return "";
  };

  useEffect(() => {
    const fetchFullBooking = async () => {
      if (!booking?.bId && !booking?.scheduledBookingId) {
        setFetchError("Booking ID is missing.");
        setLoading(false);
        return;
      }
      setLoading(true);
      setFetchError(null);
      try {
        const bookingId = booking.bId || booking.scheduledBookingId;
        const data = await getForkBookingDetails(bookingId);
        if (!data) throw new Error("No data returned from API.");
        setFullBookingData(data);
        let currentStatus = "";
        if (data.status === "I" || data.status.toLowerCase().includes("inactive") || data.status.toLowerCase() === "scheduled") currentStatus = "Pending";
        else if (data.status === "A" || data.status.toLowerCase().includes("active")) currentStatus = "Active";
        else if (data.status === "C" || data.status.toLowerCase().includes("cancel")) currentStatus = "Cancelled";
        else if (data.status === "Completed") currentStatus = "Completed";
        setSelectedStatus(currentStatus);
      } catch (err) {
        setFetchError(err.message || "An error occurred while fetching booking details.");
        setSelectedStatus(booking.status || "Pending");
      } finally {
        setLoading(false);
      }
    };
    fetchFullBooking();
  }, [booking]);

  useEffect(() => {
    const loadWorkAreas = async () => {
      setLoadingWorkAreas(true);
      try {
        const data = await getAllWorkAreas();
        setWorkAreas(data);
      } catch (err) {} finally {
        setLoadingWorkAreas(false);
      }
    };
    loadWorkAreas();
  }, []);

  const handleStatusChange = (newStatus) => {
    setSelectedStatus(newStatus);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentStatus = booking.status;
    if (currentStatus !== "Pending" && currentStatus !== "Active" && currentStatus !== "Enroute" && currentStatus !== "In Progress") {
      toast.error("Only pending bookings can be marked as completed");
      return;
    }
    if (selectedStatus !== "Completed") {
      toast.error("Only 'Complete' action is allowed");
      return;
    }
    const bookingId = booking.bId || booking.scheduledBookingId;
    const now = new Date();
    const bookingDT = now.toISOString().slice(0, 19).replace("T", " ");
    const bsTime = now.toISOString().slice(0, 19).replace("T", " ");
    const updatePayload = {
      bId: bookingId || "",
      vId: fullBookingData?.vId || booking.vehicleId,
      dSNo: fullBookingData?.dSNo || booking.dSNo,
      slatitude: fullBookingData?.slatitude,
      slongitude: fullBookingData?.slongitude,
      elatitude: fullBookingData?.elatitude,
      elongitude: fullBookingData?.elongitude,
      status: "CO",
      bookingDT: bookingDT,
      bsTime: bsTime,
      beTime: fullBookingData?.beTime || null,
      totalDestence: fullBookingData?.totalDestence || "0",
      dlongitude: fullBookingData?.dlongitude,
      dlatitude: fullBookingData?.dlatitude,
      bookingSno: fullBookingData?.bookingSno || booking.bookedBy,
      WorkArea: fullBookingData?.WorkArea || booking.workArea || null,
      WorkScope: fullBookingData?.WorkScope || booking.workScope || null,
      Priority: fullBookingData?.Priority || booking.priority || null,
      From: fullBookingData?.From || booking.fromLocation,
      TO: fullBookingData?.TO || booking.toLocation,
      Remark: fullBookingData?.Remark || booking.remark || "",
      SubBook: fullBookingData?.SubBook,
      BookingStatus: "R"
    };
    await onSave(updatePayload);
  };

  const getBookingInfo = () => {
    return {
      id: booking.bId || booking.scheduledBookingId,
      vehicleId: booking.vehicleId || fullBookingData?.vId || "N/A",
      fromLocation: booking.fromLocation || fullBookingData?.From || "N/A",
      toLocation: booking.toLocation || fullBookingData?.TO || "N/A",
      date: booking.bookedDate || (fullBookingData?.bsTime ? parseDateFromTime(fullBookingData.bsTime) : "N/A"),
      time: booking.startTime ? `${booking.startTime} - ${booking.endTime}` : 
            (fullBookingData?.bsTime ? `${parseTimeFromBooking(fullBookingData.bsTime)} - ${parseTimeFromBooking(fullBookingData.beTime)}` : "N/A"),
    };
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-8 text-center">
          <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
          <p className="text-sm text-gray-500">Loading booking details...</p>
        </div>
      </div>
    );
  }

  const info = getBookingInfo();
  const currentStatus = booking.status;
  const canMarkComplete = currentStatus === "Pending" || currentStatus === "Active" || currentStatus === "Enroute" || currentStatus === "In Progress";

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-blue-50 rounded-lg">
              <Edit3 size={16} className="text-blue-600" />
            </div>
            <h2 className="text-base font-semibold text-gray-900">Update Booking Status</h2>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
            <X size={16} className="text-gray-400" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          {fetchError && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
              <p className="text-xs text-yellow-700">{fetchError}</p>
            </div>
          )}

          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <h3 className="text-xs font-semibold text-gray-700 mb-2">Booking Details</h3>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>
                <label className="text-[10px] font-medium text-gray-500">Booking ID</label>
                <p className="text-xs font-mono text-gray-900">{info.id}</p>
              </div>
              <div>
                <label className="text-[10px] font-medium text-gray-500">Vehicle</label>
                <p className="text-xs text-gray-900">{info.vehicleId}</p>
              </div>
              <div className="col-span-2">
                <label className="text-[10px] font-medium text-gray-500">Route</label>
                <p className="text-xs text-gray-900">{info.fromLocation} → {info.toLocation}</p>
              </div>
              <div>
                <label className="text-[10px] font-medium text-gray-500">Date</label>
                <p className="text-xs text-gray-900">{info.date}</p>
              </div>
              <div>
                <label className="text-[10px] font-medium text-gray-500">Time</label>
                <p className="text-xs text-gray-900">{info.time}</p>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">Current Status</label>
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                currentStatus === "Pending" ? "bg-yellow-50 text-yellow-700" :
                currentStatus === "Completed" ? "bg-emerald-50 text-emerald-700" :
                "bg-red-50 text-red-700"
              }`}>
                {currentStatus}
              </span>
            </div>

            <label className="block text-xs font-medium text-gray-700 mb-2">Update Status To</label>
            <div className="space-y-2">
              {canMarkComplete && (
                <button
                  type="button"
                  onClick={() => handleStatusChange("Completed")}
                  className={`w-full flex items-center justify-between p-3 rounded-lg border-2 transition ${
                    selectedStatus === "Completed"
                      ? "border-emerald-500 bg-emerald-50"
                      : "border-gray-200 hover:border-emerald-200"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <CheckCircle size={18} className={selectedStatus === "Completed" ? "text-emerald-600" : "text-gray-400"} />
                    <div className="text-left">
                      <p className="text-sm font-medium text-gray-900">Complete</p>
                      <p className="text-xs text-gray-500">Mark this booking as completed</p>
                    </div>
                  </div>
                  {selectedStatus === "Completed" && <CheckCircle size={16} className="text-emerald-600" />}
                </button>
              )}
              
              {!canMarkComplete && currentStatus !== "Completed" && (
                <div className="p-3 bg-gray-100 rounded-lg text-center">
                  <p className="text-xs text-gray-500">
                    {currentStatus === "Cancelled" 
                      ? "Cancelled bookings cannot be modified" 
                      : "This booking cannot be modified"}
                  </p>
                </div>
              )}

              {currentStatus === "Completed" && (
                <div className="p-3 bg-emerald-50 rounded-lg text-center">
                  <CheckCircle size={16} className="text-emerald-600 inline mr-2" />
                  <p className="text-xs text-emerald-700 inline">This booking has already been completed</p>
                </div>
              )}
            </div>
          </div>

          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
              Cancel
            </button>
            <button 
              type="submit" 
              disabled={isSaving || !canMarkComplete || selectedStatus === currentStatus} 
              className="flex-1 px-3 py-1.5 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition disabled:opacity-50 flex items-center justify-center gap-1"
            >
              {isSaving ? <><Loader size={14} className="animate-spin" /> Saving...</> : "Update Status"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Booking Details Modal Component
const BookingDetailsModal = ({ booking, onClose, onCancel, isCancelling }) => {
  const [detailedData, setDetailedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const [resources, setResources] = useState([]);
  const [vehicleCatalog, setVehicleCatalog] = useState({});

  useEffect(() => {
    const fetchBookingDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        const bidValue = booking.bId || booking.scheduledBookingId;
        const [response, vehiclesResponse] = await Promise.all([
          api.get(`BookingRegister/GetMainForkBookingDetails?bid=${bidValue}`),
          api.get("VehicleDetails/GetVehicleDetails"),
        ]);
        const vehicles = vehiclesResponse?.data?.resultSet || [];
        const vehicleMap = vehicles.reduce((acc, item) => { if (item?.vehicleId) acc[item.vehicleId] = item; return acc; }, {});
        setVehicleCatalog(vehicleMap);
        if (response.data?.resultSet && Array.isArray(response.data.resultSet) && response.data.resultSet.length > 0) {
          setDetailedData(response.data.resultSet);
          setVehicleInfo(response.data.resultSet[0]);
          setResources(response.data.resultSet.slice(1));
        } else {
          setError("No booking details found");
        }
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load booking details");
      } finally {
        setLoading(false);
      }
    };
    if (booking?.scheduledBookingId || booking?.bId) fetchBookingDetails();
  }, [booking?.scheduledBookingId, booking?.bId]);

  const formatReadableDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  const formatReadableTime = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending": return "bg-yellow-50 text-yellow-700 border-yellow-200";
      case "Completed": return "bg-emerald-50 text-emerald-700 border-emerald-200";
      case "Cancelled": return "bg-red-50 text-red-700 border-red-200";
      default: return "bg-gray-50 text-gray-700 border-gray-200";
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-8 text-center">
          <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
          <p className="text-sm text-gray-500">Loading booking details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-blue-50 rounded-lg">
              <Eye size={16} className="text-blue-600" />
            </div>
            <h2 className="text-base font-semibold text-gray-900">Booking Details</h2>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
            <X size={16} className="text-gray-400" />
          </button>
        </div>

        <div className="p-6 space-y-5">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-xs text-red-700">{error}</p>
            </div>
          )}

          {!error && vehicleInfo && (
            <>
              <div className="flex items-center gap-2">
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(booking.status)}`}>
                  {booking.status === "Pending" && <ClockIcon size={10} />}
                  {booking.status === "Completed" && <CheckCircle size={10} />}
                  {booking.status === "Cancelled" && <XCircle size={10} />}
                  {booking.status}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-lg p-3">
                  <label className="text-[10px] font-medium text-gray-500 uppercase">Vehicle ID</label>
                  <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.vId || "N/A"}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <label className="text-[10px] font-medium text-gray-500 uppercase">Booking ID</label>
                  <p className="text-sm font-semibold text-gray-900 mt-1 font-mono">{vehicleInfo.bId || "N/A"}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <label className="text-[10px] font-medium text-gray-500 uppercase flex items-center gap-1">📅 Date</label>
                  <p className="text-sm font-semibold text-gray-900 mt-1">{formatReadableDate(vehicleInfo.bsTime)}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <label className="text-[10px] font-medium text-gray-500 uppercase flex items-center gap-1">⏰ Time</label>
                  <p className="text-sm font-semibold text-gray-900 mt-1">{formatReadableTime(vehicleInfo.bsTime)} - {formatReadableTime(vehicleInfo.beTime)}</p>
                </div>
              </div>

              {(vehicleInfo.From || vehicleInfo.TO) && (
                <div className="bg-gray-50 rounded-lg p-3">
                  <h3 className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1">📍 Route</h3>
                  <div className="space-y-2">
                    {vehicleInfo.From && (
                      <div className="flex items-center gap-2">
                        <div className="w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold">A</div>
                        <p className="text-sm text-gray-900">{vehicleInfo.From}</p>
                      </div>
                    )}
                    {vehicleInfo.TO && (
                      <div className="flex items-center gap-2">
                        <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-[10px] font-bold">B</div>
                        <p className="text-sm text-gray-900">{vehicleInfo.TO}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(vehicleInfo.Priority || vehicleInfo.WorkArea) && (
                <div className="grid grid-cols-2 gap-3">
                  {vehicleInfo.Priority && (
                    <div className="bg-gray-50 rounded-lg p-3">
                      <label className="text-[10px] font-medium text-gray-500 uppercase">Priority</label>
                      <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.Priority}</p>
                    </div>
                  )}
                  {vehicleInfo.WorkArea && (
                    <div className="bg-gray-50 rounded-lg p-3">
                      <label className="text-[10px] font-medium text-gray-500 uppercase">Work Area</label>
                      <p className="text-sm font-semibold text-gray-900 mt-1">{vehicleInfo.WorkArea}</p>
                    </div>
                  )}
                </div>
              )}

              {vehicleInfo.Remark && (
                <div className="bg-gray-50 rounded-lg p-3">
                  <label className="text-[10px] font-medium text-gray-500 uppercase">Remarks</label>
                  <p className="text-sm text-gray-700 mt-1">{vehicleInfo.Remark}</p>
                </div>
              )}
            </>
          )}
        </div>

        <div className="border-t border-gray-100 px-6 py-4 flex gap-3">
          <button onClick={onClose} className="flex-1 px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
            Close
          </button>
          {booking.status !== "Cancelled" && booking.status !== "Completed" && (
            <button onClick={() => { if (window.confirm("Cancel this booking?")) onCancel(booking.scheduledBookingId); }} disabled={isCancelling} className="flex-1 px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50 flex items-center justify-center gap-1">
              <XCircle size={14} /> {isCancelling ? "Cancelling..." : "Cancel Booking"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Main ScheduledBookingList Component
const ScheduledBookingList = () => {
  const { bookings, cancel, cancellingMap, loadBookings } = useScheduledBookings();
  const [statusFilter, setStatusFilter] = useState("All");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [editingBooking, setEditingBooking] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [viewMode, setViewMode] = useState('table');

  // Detect screen size for default view
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setViewMode('card');
      } else {
        setViewMode('table');
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const filteredBookings = useMemo(() => {
    if (statusFilter === "All") return bookings;
    return bookings.filter((booking) => booking.status === statusFilter);
  }, [bookings, statusFilter]);

  const handleCancel = async (scheduledBookingId) => {
    if (!scheduledBookingId) return;
    try {
      await cancel(scheduledBookingId);
      
      // Send WebSocket notification for cancellation
      try {
        bookingWS.sendCancellation({
          bId: scheduledBookingId,
          dSNo: editingBooking?.dSNo,
          vId: editingBooking?.vehicleId,
          status: "C",
        });
        console.log("✅ Cancellation notification sent via WebSocket");
      } catch (wsErr) {
        console.warn("Failed to send WebSocket cancellation notification:", wsErr);
      }
      
      setSelectedBooking(null);
    } catch (error) {
      console.error("Failed to cancel scheduled booking:", error);
    }
  };

  // Update booking status using appropriate API - Array format with WebSocket notification
  const handleStatusUpdate = async (updatePayload) => {
    if (!editingBooking) return;
    setIsSaving(true);
    try {
      const payloadArray = [updatePayload];
      console.log("Sending payload array:", JSON.stringify(payloadArray, null, 2));
      
      const response = await api.put(`BookingRegister/PostForkBooking`, payloadArray);
      const responseData = response?.data;
      
      console.log("Response:", responseData);
      
      if (responseData?.statusCode && responseData.statusCode !== 200) {
        throw new Error(responseData.result || `Backend error: ${responseData.statusCode}`);
      }
      
      // 🔴 Send WebSocket notification for completion
      try {
        bookingWS.sendStatusUpdate({
          bId: updatePayload.bId,
          reqId: editingBooking.reqId || editingBooking.ReqId,
          status: "CO",
          dSNo: updatePayload.dSNo,
          vId: updatePayload.vId,
          bookingSno: updatePayload.bookingSno,
          dlatitude: updatePayload.dlatitude,
          dlongitude: updatePayload.dlongitude,
        });
        console.log("✅ Completion notification sent via WebSocket");
      } catch (wsErr) {
        console.warn("Failed to send WebSocket completion notification:", wsErr);
      }
      
      toast.success("Booking status updated successfully");
      setEditingBooking(null);
      setSelectedBooking(null);
      await loadBookings();
    } catch (error) {
      console.error("Failed to update booking status:", error);
      toast.error(error.message || "Failed to update booking status");
    } finally {
      setIsSaving(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "bg-yellow-50 text-yellow-700";
      case "Completed":
        return "bg-emerald-50 text-emerald-700";
      case "Cancelled":
        return "bg-red-50 text-red-700";
      default:
        return "bg-gray-50 text-gray-700";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Pending":
        return <ClockIcon size={10} />;
      case "Completed":
        return <CheckCircle size={10} />;
      case "Cancelled":
        return <XCircle size={10} />;
      default:
        return null;
    }
  };

  // Mobile Card Component
  const BookingCard = ({ booking }) => {
    const statusColor = getStatusColor(booking.status);
    const statusIcon = getStatusIcon(booking.status);
    const fromValue = booking.fromLocation || booking.From || booking.workArea;
    const toValue = booking.toLocation || booking.TO;

    return (
      <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition">
        <div className="p-3 border-b border-gray-100 bg-gray-50">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-gray-900">#{booking.bId || booking.scheduledBookingId}</span>
              <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${statusColor}`}>
                {statusIcon}
                {booking.status}
              </span>
            </div>
          </div>
          {(booking.bookedDate || booking.startTime) && (
            <p className="text-[10px] text-gray-500 mt-1">
              {booking.bookedDate || ""} {booking.startTime ? `• ${booking.startTime}` : ""}
            </p>
          )}
        </div>

        <div className="p-3 space-y-2">
          <div className="flex items-start gap-2">
            <div className="w-5 h-5 bg-emerald-500 rounded-full flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">A</div>
            <p className="text-xs text-gray-700 flex-1">{fromValue || "—"}</p>
          </div>
          <div className="flex items-start gap-2">
            <div className="w-5 h-5 bg-red-500 rounded-full flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">B</div>
            <p className="text-xs text-gray-700 flex-1">{toValue || "—"}</p>
          </div>
          {(booking.vehicleId || booking.vehicleName) && (
            <div className="pt-2 border-t border-gray-100">
              <div className="flex items-center gap-1.5">
                <Truck size={12} className="text-gray-400" />
                <span className="text-xs font-medium text-gray-900">{booking.vehicleId || booking.vehicleName}</span>
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-2 p-3 bg-gray-50 border-t border-gray-100">
          <button onClick={() => setSelectedBooking(booking)} className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition">
            <Eye size={12} /> View
          </button>
          {booking.status === "Pending" && (
            <button 
              onClick={() => setEditingBooking(booking)} 
              className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition"
            >
              <Edit3 size={12} /> Complete
            </button>
          )}
          {(booking.status === "Pending" || booking.status === "Active" || booking.status === "Enroute" || booking.status === "In Progress") && (
                            <button onClick={() => setEditingBooking(booking)} className="flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition" title="Mark as Complete">
                              <Edit3 size={14} />
                            </button>
                          )}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-4">
      <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-center gap-2">
            <Calendar size={16} className="text-gray-500" />
            <h2 className="text-sm font-semibold text-gray-900">Your Bookings</h2>
          </div>
          <div className="flex gap-1.5 overflow-x-auto pb-1">
            {["All", "Pending", "Completed", "Cancelled"].map((status) => (
              <button
                key={status}
                onClick={() => setStatusFilter(status)}
                className={`px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap transition ${
                  statusFilter === status
                    ? "bg-gray-900 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {status}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="hidden md:flex justify-end">
        <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg">
          <button
            onClick={() => setViewMode('table')}
            className={`px-2.5 py-1 text-xs font-medium rounded transition ${
              viewMode === 'table' 
                ? 'bg-white text-gray-900 shadow-sm' 
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Table size={12} className="inline mr-1" />
            Table View
          </button>
          <button
            onClick={() => setViewMode('card')}
            className={`px-2.5 py-1 text-xs font-medium rounded transition ${
              viewMode === 'card' 
                ? 'bg-white text-gray-900 shadow-sm' 
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Grid size={12} className="inline mr-1" />
            Card View
          </button>
        </div>
      </div>

      {/* Desktop Table View */}
      {viewMode === 'table' && (
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hidden md:block">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Vehicle</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">From → To</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {filteredBookings.map((booking) => {
                  const fromValue = booking.fromLocation || booking.From || booking.workArea || "—";
                  const toValue = booking.toLocation || booking.TO || "—";
                  const statusColor = getStatusColor(booking.status);
                  const statusIcon = getStatusIcon(booking.status);
                  
                  return (
                    <tr key={booking.bId || booking.scheduledBookingId} className="hover:bg-gray-50/50 transition">
                      <td className="py-2.5 px-3">
                        <span className="text-xs font-mono font-medium text-gray-900">#{booking.bId || booking.scheduledBookingId}</span>
                      </td>
                      <td className="py-2.5 px-3">
                        <div className="flex items-center gap-1.5">
                          <Truck size={12} className="text-gray-400" />
                          <span className="text-xs text-gray-700">{booking.vehicleId || booking.vehicleName || "—"}</span>
                        </div>
                      </td>
                      <td className="py-2.5 px-3">
                        <div className="flex items-center gap-1 text-xs text-gray-600">
                          <span className="truncate max-w-[120px]">{fromValue}</span>
                          <ChevronRight size={10} className="text-gray-400" />
                          <span className="truncate max-w-[120px]">{toValue}</span>
                        </div>
                      </td>
                      <td className="py-2.5 px-3">
                        <div className="text-xs text-gray-600">
                          <div>{booking.bookedDate || "—"}</div>
                          <div className="text-[10px] text-gray-400">{booking.startTime ? `${booking.startTime} - ${booking.endTime || "—"}` : "—"}</div>
                        </div>
                      </td>
                      <td className="py-2.5 px-3">
                        <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${statusColor}`}>
                          {statusIcon}
                          {booking.status}
                        </span>
                      </td>
                      <td className="py-2.5 px-3">
                        <div className="flex gap-1.5">
                          <button onClick={() => setSelectedBooking(booking)} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition" title="View">
                            <Eye size={14} />
                          </button>
                          {(booking.status === "Pending" || booking.status === "Active" || booking.status === "Enroute" || booking.status === "In Progress") && (
                            <button onClick={() => setEditingBooking(booking)} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition" title="Mark as Complete">
                              <Edit3 size={14} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Mobile Card View */}
      {viewMode === 'card' && (
        <div className="grid grid-cols-1 gap-3">
          {filteredBookings.map((booking) => (
            <BookingCard key={booking.bId || booking.scheduledBookingId} booking={booking} />
          ))}
        </div>
      )}

      {/* Empty State */}
      {filteredBookings.length === 0 && (
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-12 text-center">
          <div className="flex flex-col items-center gap-2">
            <Calendar size={32} className="text-gray-300" />
            <p className="text-sm font-medium text-gray-900">No Bookings Found</p>
            <p className="text-xs text-gray-500">
              {statusFilter === "All" ? "You haven't created any bookings yet." : `No ${statusFilter.toLowerCase()} bookings.`}
            </p>
          </div>
        </div>
      )}
 
      {selectedBooking && (
        <BookingDetailsModal
          booking={selectedBooking}
          onClose={() => setSelectedBooking(null)}
          onCancel={handleCancel}
          isCancelling={cancellingMap?.[selectedBooking.scheduledBookingId]}
        />
      )}

      {editingBooking && (
        <StatusEditModal
          booking={editingBooking}
          onClose={() => setEditingBooking(null)}
          onSave={handleStatusUpdate}
          isSaving={isSaving}
        />
      )}
    </div>
  );
};

export default ScheduledBookingList;